import axios from "axios";

const API_BASE_URL =
  import.meta?.env?.VITE_API_URL ||
  process.env.REACT_APP_API_URL ||
  "https://graficosb-production.up.railway.app";

const api = axios.create({ baseURL: `${API_BASE_URL}/api`, timeout: 60000 });

// Reintento simple ante timeout
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    if (error?.code === "ECONNABORTED" && !error.config.__retried) {
      error.config.__retried = true;
      return api.request(error.config);
    }
    return Promise.reject(error);
  }
);

const safe = async (fn, fallback = []) => {
  try { return await fn(); }
  catch (err) {
    console.error("[trabajoApi] Error:", err?.message || err);
    return fallback;
  }
};

export const getAnual = async () =>
  safe(async () => (await api.get("/trabajo/anual")).data?.rows ?? []);

export const getDataset = async () =>
  safe(async () => (await api.get("/trabajo/dataset")).data?.rows ?? []);

export const getTasas = async (params = {}) =>
  safe(async () => (await api.get("/trabajo/tasas", { params })).data?.rows ?? []);

export const getPiramide = async (params = {}) =>
  safe(async () => (await api.get("/trabajo/piramide", { params })).data?.rows ?? []);

export const getSerieBC = async ({ serieId, startDate = "", endDate = "" }) =>
  safe(async () => (await api.post("/banco-central/serie", { serieId, startDate, endDate })).data);

const seriesFromDataset = (ds = []) => {
  const acc = new Map();
  ds.forEach((r) => {
    const a = Number(r.anio);
    if (!Number.isFinite(a)) return;
    const sexo = String(r.sexo || "").trim();
    const v = Number(r.ingreso_promedio ?? NaN);
    if (!Number.isFinite(v)) return;
    if (!acc.has(a)) acc.set(a, { Hombres: { s: 0, c: 0 }, Mujeres: { s: 0, c: 0 } });
    if (sexo === "Hombre") { acc.get(a).Hombres.s += v; acc.get(a).Hombres.c += 1; }
    else if (sexo === "Mujer") { acc.get(a).Mujeres.s += v; acc.get(a).Mujeres.c += 1; }
  });
  return Array.from(acc.entries()).map(([anio, g]) => {
    const hombres = g.Hombres.c ? Math.round(g.Hombres.s / g.Hombres.c) : null;
    const mujeres = g.Mujeres.c ? Math.round(g.Mujeres.s / g.Mujeres.c) : null;
    const total = (hombres != null && mujeres != null)
      ? Math.round((hombres + mujeres) / 2)
      : (hombres ?? mujeres ?? null);
    return { anio, total, hombres, mujeres };
  }).sort((a,b) => a.anio - b.anio);
};

export const getESIIngresos = async (params = {}) => {
  try {
    const { data } = await api.get("/trabajo/esi/ingresos", { params });
    const rows = Array.isArray(data) ? data : data?.rows ?? [];
    if (rows.length > 0) return rows;
  } catch (e) {
    console.warn("[getESIIngresos] backend no disponible, usando fallback.", e?.message);
  }
  const ds = await getDataset();
  return seriesFromDataset(ds);
};

export const getESIIngresosUltimo = async () => {
  const rows = await getESIIngresos();
  if (!rows.length) return { anio: null, total: null, hombres: null, mujeres: null };
  return rows.reduce((a, b) => (a.anio > b.anio ? a : b));
};

export default {
  getAnual, getDataset, getTasas, getPiramide, getSerieBC, getESIIngresos, getESIIngresosUltimo
};
